import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { SamplingRoomTab, TMStudyTab } from '../components/SampleBulletin';

// Top-level Sampling & T&M Study tab. Pulled out of Production → IE (de-duped: the
// Sampling Room + T&M Study sub-tabs were removed from IEContent). These two screens
// are stages of the Sample Bulletin flow (sample_making → tms_in_progress); the
// components are self-contained (only need `user`) and fetch their own data.
const TABS = [
  { key: 'sampling', label: '🧵 Sampling Room' },
  { key: 'tms', label: '⏱ T&M Study' },
];

export default function SamplingTMS() {
  const { user } = useAuth();
  const [tab, setTab] = useState('sampling');
  return (
    <div style={{ minHeight: '100vh', background: 'transparent', fontFamily: 'inherit' }}>
      <div style={{ background: 'white', borderBottom: '1px solid #eee', padding: '0 24px', display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '12px 18px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 14,
            fontWeight: tab === t.key ? 700 : 400, color: tab === t.key ? '#3B3A8F' : '#777',
            borderBottom: tab === t.key ? '3px solid #3B3A8F' : '3px solid transparent' }}>{t.label}</button>
        ))}
      </div>
      {tab === 'sampling' && <SamplingRoomTab user={user} />}
      {tab === 'tms' && <TMStudyTab user={user} />}
    </div>
  );
}
